import { render } from "./QueDiceChile.vue?vue&type=template&id=3daa1404"
import script from "./QueDiceChile.vue?vue&type=script&lang=js"
export * from "./QueDiceChile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__